/** React */
import { useState } from "react";

/** MUI icons */
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";

/** MUI */
import { IconButton, InputAdornment, } from "@mui/material";

/** Components */
import CustTextField from "./CustTextField";

export default function BaseOutlinedInput(props) {
    const { id, label, value, onChange, shrink, error } = props;

    const [showNewPassword, setShowNewPassword] = useState(false);

    const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <CustTextField
            id={id}
            fullWidth
            shrink={shrink}
            type={showNewPassword ? "text" : "password"}
            error={error}
            value={value}
            onChange={onChange}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowNewPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            {showNewPassword ? (
                                <VisibilityOff fontSize="small" color="primary" />                            
                            ) : (
                                <Visibility fontSize="small" color="primary"/>
                            )}
                        </IconButton>
                    </InputAdornment>
                )
            }}
            label={label}
        />
    );
}
